import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useUpdateNetworkMutation } from "../../redux/networkApi";

import { useTranslation } from "react-i18next";

function EditNetwork({ show, onHide, network }) {
    const { t } = useTranslation();
    const [editData, setEditData] = useState({});
    const [updateNetwork] = useUpdateNetworkMutation();

    useEffect(() => {
        if (network) {
            setEditData(network);
        }
    }, [network]);

    const handleEditSave = async () => {
        await updateNetwork(editData);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('edit')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('status')}</Form.Label>
                        <Form.Select
                            value={editData.status || ""}
                            onChange={(e) => setEditData({ ...editData, status: e.target.value })}
                        >
                            <option value="enable">{t('enable')}</option>
                            <option value="disable">{t('disable')}</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('is_default')}</Form.Label>
                        <Form.Select
                            value={editData.is_default || ""}
                            onChange={(e) => setEditData({ ...editData, is_default: e.target.value })}
                        >
                            <option value="yes">{t('yes')}</option>
                            <option value="no">{t('no')}</option>
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                    {t('save_changes')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditNetwork;
